import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import DDOption from '../models/DropdownModels';
import axios from 'axios';
import { getStorageValues } from '../CommonFunctions';
import { getApiBaseUrl } from '../../utils/apiConfig';

function ClientCompanyTypeDropdown({ onChangeDropdown, required, showTitle }) {
    const [selectedClientCompanyTypeOption, setSelectedClientCompanyTypeOption] = useState([]);
    const [getClientCompanyTypeOptions, setClientCompanyTypeOptions] = useState(new DDOption() || []);
    const [statusChanged, setClientCompanyTypeChanged] = useState(false);

    function handleChange(e, actionMeta) {
        setSelectedClientCompanyTypeOption(e);
        setClientCompanyTypeChanged(true);
        onChangeDropdown(e, actionMeta);
    };

    const fetchClientCompanyType = async () => {
        try {
            let clientCompanyTypeDetails = {
                UserId: getStorageValues('userId')
            };
            const response = await axios.get(getApiBaseUrl() + "/clientCompanyTypelist", {params: clientCompanyTypeDetails});
            if (response.status === 200) {
                setClientCompanyTypeDropdownData(response.data.data[0]);
            }
        } catch (error) {
            console.log(error);
        }
    };

    function setClientCompanyTypeDropdownData(cct) {
        let allModuleOpt = [];
        allModuleOpt = cct.map(p => ({ value: p.ClientCompanyTypeId, label: p.ClientCompanyTypeName, name: p.ClientCompanyTypeName, description: p.Discription, isFixed: false, isDisabled: false, groupId: null }))
        setClientCompanyTypeOptions(allModuleOpt);
    }

    useEffect(() => {
        fetchClientCompanyType();
    }, []);
    return (
        <div >
            { showTitle ? 
                <label className="form-label">
                    ClientCompanyType { required === true ? <span style={{ color: "red" }}>*</span> : "" }
                </label>
                : ""
            }
            <Select
                name="ClientCompanyTypeId"
                value={selectedClientCompanyTypeOption ? selectedClientCompanyTypeOption : []}
                isClearable={true}
                options={getClientCompanyTypeOptions || []}
                onChange={handleChange}
            />
        </div>
    )
}

export default ClientCompanyTypeDropdown